import React, { useState, useEffect, useRef } from "react";

import DownloadReportSvg from "../../../../../images/download-report.svg";
import BarChart from "../../../../../_components/common//BarChart/index.jsx";
import { ScoreBoard } from "../../../../../_components/common/ScoreBoard/index.jsx";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import axios from "axios";
import addAccessTokenToUrl from "../../../../Utils/Axios/addTokenToUrl";
import { getLifeWheelColor } from "../../../../Utils/colors.js";
import { DownloadPdfEndPoint, BackendEndPoint } from "../../../../../_pages/DashBoard/viewReport/DownloadPdfEndPoint.js";
import Pdfloader from "../../../Data-loader/pdf-loader";
import { toast } from "react-toastify";
import LineChart from "../../../../../_components/common/LineChart/LineChart.jsx";
import Legend from "../../../Legend/Legend.jsx";
import { lifeWheelOrientationOrder } from "../../../../Utils/orientation.js";
import RadarChartWheel from "../../../../../_components/common/RadarChartWheel/RadarChartWheel.jsx";
import useOrientationChange from "../../../../Utils/useOrientationChange.jsx";



export default function ReportChartComponent({ reload }) {
  const [lifeWheelBardData, setLifeWheelBardData] = useState([]);

  const [color1, setColors] = useState([])
  const [cotterColor, setCotterColor] = useState([])
  const [hubWheelBardData, setHubWheelBardData] = useState([]);
  const [cotterWheelBardData, setCotterWheelBardData] = useState([]);
  const [uniqueHUbCotter, setUniqueHUbCotter] = useState(new Map())
  const { colorMap1: colorMapForLifeWheel1, colorMap2: colorMapForLifeWheel2, colorMap3: colorMapForLifeWheel3, lifeWheelColorMappedToOrientation } = getLifeWheelColor();
  const [lifeWheelOrientationColors, setLifeWheelOrientationColors] = useState(new Map());

  useOrientationChange();

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isMobile = screenWidth < 431;
  const isTablet = screenWidth < 1000;

  useEffect(() => {
    const newLifeWheelOrientationColors = new Map();
    color1.forEach((c, i) => {
      if (i % 3 === 0) {
        newLifeWheelOrientationColors.set(i, {
          "Achievement": colorMapForLifeWheel1[lifeWheelColorMappedToOrientation.Achievement],
          "Leadership": colorMapForLifeWheel1[lifeWheelColorMappedToOrientation.Leadership],
          "Relationship": colorMapForLifeWheel1[lifeWheelColorMappedToOrientation.Relationship],
          "Learning": colorMapForLifeWheel1[lifeWheelColorMappedToOrientation.Learning],
          "Nurturing": colorMapForLifeWheel1[lifeWheelColorMappedToOrientation.Nurturing],
        });
      }
      else if (i % 3 === 1) {
        newLifeWheelOrientationColors.set(i, {
          "Achievement": colorMapForLifeWheel2[lifeWheelColorMappedToOrientation.Achievement],
          "Leadership": colorMapForLifeWheel2[lifeWheelColorMappedToOrientation.Leadership],
          "Relationship": colorMapForLifeWheel2[lifeWheelColorMappedToOrientation.Relationship],
          "Learning": colorMapForLifeWheel2[lifeWheelColorMappedToOrientation.Learning],
          "Nurturing": colorMapForLifeWheel2[lifeWheelColorMappedToOrientation.Nurturing],
        });
      }
      else if (i % 3 === 2) {
        newLifeWheelOrientationColors.set(i, {
          "Achievement": colorMapForLifeWheel3[lifeWheelColorMappedToOrientation.Achievement],
          "Leadership": colorMapForLifeWheel3[lifeWheelColorMappedToOrientation.Leadership],
          "Relationship": colorMapForLifeWheel3[lifeWheelColorMappedToOrientation.Relationship],
          "Learning": colorMapForLifeWheel3[lifeWheelColorMappedToOrientation.Learning],
          "Nurturing": colorMapForLifeWheel3[lifeWheelColorMappedToOrientation.Nurturing],
        });
      }
    });

    setLifeWheelOrientationColors(newLifeWheelOrientationColors);
  }, [color1]);

  useEffect(() => {
    const newUniqueColors = new Map();
    cotterColor.forEach((c, i) => {
      const newUniqueColorSet = new Set(c);
      newUniqueColors.set(i, newUniqueColorSet);
    });

    setUniqueHUbCotter(newUniqueColors);
  }, [cotterColor])

  useEffect(() => {
    if (lifeWheelBardData.datasets) {
      const colorSets1 = lifeWheelBardData.datasets.map(dataset => dataset.backgroundColor);
      setColors(colorSets1);
    }
  }, [lifeWheelBardData.datasets]);

  useEffect(() => {
    if (cotterWheelBardData.datasets) {
      const colorSets1 = cotterWheelBardData.datasets.map(dataset => dataset.backgroundColor);
      setCotterColor(colorSets1);
    }
  }, [cotterWheelBardData.datasets]);

  const [pdfLoading, setPdfLoading] = useState(false);
  const [radarData, setRadarData] = useState([]);
  const [radarScoreData, setRadarScoreData] = useState([]);
  const [downloadData, setDownloadData] = useState([]);

  const [scoreData, setScoreData] = useState([]);
  const [hubScoreData, setHubScoreData] = useState([]);
  const [cotterScoreData, setCotterScoreData] = useState([]);
  const [responseData, setDataResponse] = useState([]);
  const filterData = JSON.parse(localStorage.getItem("filterData"));
  const participantId = localStorage.getItem("participant_id");
  const assessmentIds = localStorage.getItem("assessmentIds");
  const instrumentType = filterData.formData.dropdown2;
  const storedOrientation = filterData.formData.orientation;
  const relation = filterData.formData.relation
  const relationId = filterData.formData.relationId





  const storedIdsArray = assessmentIds.split(",");


  const [additionalReportData, setAdditionalReportData] = useState({
    organisationImage: '',
    isWhiteLabeled: false
  });





  const [selectedOrientation, setSelectedOrientation] = useState(
    storedOrientation[0]
  );
  const hubAllowedAttributeNames = [
    "Involvement",
    "Sensitivity",
    "People Involvement",
    "Task Involvement",
    "Understanding",
    "Integration",
    "Conviction",
  ];
  const cotterAllowedAttributeNames = [
    "Planning",
    "Time sense",
    "Appropriateness",
    "Organized",
    "Prioritization",
    "Structured",
    "Time for Learning",
    "Context Sensitivity",
  ];
  const handleSelectedOrientationChange = (orientation) => {
    setSelectedOrientation(orientation);
  };
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleInstrumentDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleDownloadPdf = () => {

    setPdfLoading(true);
    axios
      .post(`${BackendEndPoint}assessments/report/yoy-self/download`, {
        data: {
          data: downloadData, instrument: instrumentType === "LOI Self" ? "self" : "360", organisation__organisation_image: additionalReportData.organisationImage,

          seller__is_white_labeled_solution: additionalReportData.isWhiteLabeled
        }, type: 'pdf'
      })
      .then((response) => {
        setPdfLoading(false);
        const filename = response.data.r_link.endUrl.substring(
          response.data.r_link.endUrl.lastIndexOf("/") + 1
        );
        window.open(`${DownloadPdfEndPoint}${filename}`);
      })
      .catch((error) => {
        setPdfLoading(false);
        console.error("Error downloading PDF:", error);
      });
  };
  const handleDownloadPpt = () => {
    axios
      .post(`${BackendEndPoint}assessments/report/yoy-self/download`, {
        data: {
          data: downloadData, instrument: instrumentType === "LOI Self" ? "self" : "360", organisation__organisation_image: additionalReportData.organisationImage,
          
          seller__is_white_labeled_solution: additionalReportData.isWhiteLabeled
        }, type: 'ppt'
      })
      .then((response) => {
        const filename = response.data.r_link.file.substring(
          response.data.r_link.file.lastIndexOf("/") + 1
        );
        window.location.replace(`${DownloadPdfEndPoint}${filename}`);
        toast["success"](`Download successful!`, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      })
      .catch((error) => {
        console.error("Error downloading PPT:", error);
        toast["error"](`Download failed. Please try again.`, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };


  function assignColors(bardData) {
    const { colorMap1, colorMap2, colorMap3 } = getLifeWheelColor();
    const colorMaps = [colorMap1, colorMap2, colorMap3];
    bardData.datasets.forEach((dataset, index) => {
      const colorMap = colorMaps[index % colorMaps.length];
      const backgroundColors = [];
      const borderColors = [];

      bardData.labels.forEach(label => {
        let color = "grey";

        Object.keys(colorMap).forEach(key => {
          const labels = key.split(", ");
          if (labels.includes(label)) {
            color = colorMap[key];
          }
        });

        backgroundColors.push(color);
        borderColors.push(color);
      });

      dataset.backgroundColor = backgroundColors;
      dataset.borderColor = borderColors;
    });

    return {
      attributeColors: bardData
    };
  }

  function assignColors2(bardData) {
    const colorMap1 = {
      "Appropriateness": "#77D1EB",
      "Organized, Prioritization": "#5B9AC8",
      "Planning, Time sense": "#F39F9C",
      "Context Sensitivity": "#F3BF77",
      "Structured, Time for Learning": "#96D6B6",
    };
    const colorMap2 = {
      "Appropriateness": "#2DB2D9",
      "Organized, Prioritization": "#15598B",
      "Planning, Time sense": "#E97975",
      "Context Sensitivity": "#DB9B43",
      "Structured, Time for Learning": "#59A27E",
    };
    const colorMap3 = {
      "Appropriateness": "#1d7b9c",
      "Organized, Prioritization": "#0d3f60",
      "Planning, Time sense": "#a53938",
      "Context Sensitivity": "#8d6d27",
      "Structured, Time for Learning": "#3b7054",
    };

    const colorMaps = [colorMap1, colorMap2, colorMap3];
    bardData.datasets.forEach((dataset, index) => {

      const colorMap = colorMaps[index % colorMaps.length];
      const backgroundColors = [];
      const borderColors = [];

      bardData.labels.forEach(label => {
        let color = "grey";

        Object.keys(colorMap).forEach(key => {
          const labels = key.split(", ");
          if (labels.includes(label)) {
            color = colorMap[key];
          }
        });

        backgroundColors.push(color);
        borderColors.push(color);
      });

      dataset.backgroundColor = backgroundColors;
      dataset.borderColor = borderColors;
    });

    return bardData;
  }

  useEffect(() => {
    assessmentReportList()
      .then((response) => {

        const attNameSet = new Set();
        const radar360Set = new Set();
        const hubAttNameSet = new Set();
        const cotterAttNameSet = new Set();
        setDataResponse(response.data.data);

        if (response.data.data && response.data.data.length > 0) {
          setAdditionalReportData({
            organisationImage: response.data.data[0].organisation__organisation_image,
            isWhiteLabeled: response.data.data[0].seller__is_white_labeled_solution
          });
        }

        response.data.data.forEach((item) => {
          item.report_parts.forEach((part) => {
            if (
              storedOrientation.includes(part.orientation__orientation_name)
            ) {

              if (part.attributes && part.attributes.length > 0) {
                let addedAttributes = 0;
                part.attributes.forEach((attribute) => {
                  radar360Set.add(attribute.att_name)
                  if (addedAttributes < 3) {
                    attNameSet.add(attribute.att_name);
                    addedAttributes++;
                  }
                  if (
                    hubAllowedAttributeNames.includes(
                      String(attribute.att_name)
                    )
                  ) {
                    hubAttNameSet.add(attribute.att_name);
                  }
                  if (
                    cotterAllowedAttributeNames.includes(
                      String(attribute.att_name)
                    )
                  ) {
                    cotterAttNameSet.add(attribute.att_name);
                  }
                });
              }
            }
          });
        });

        const uniqueAttNames = Array.from(attNameSet);
        const hubUniqueAttNames = Array.from(hubAttNameSet);
        const cotterUniqueAttNames = Array.from(cotterAttNameSet);
        const radarAttributeNames = Array.from(radar360Set);
        const color = [
          "#94ddf3ab",
          "#9fecedad",
          "#91eeaea3",
        ];
        const data = {
          labels: uniqueAttNames,
          datasets: response.data.data.map((item, index) => ({
            label: relation.length > 1 ? item.report_type : `${new Date(item.created).toISOString().split("T")[0]}`,
            data: item.report_parts
              .filter((part) =>
                storedOrientation.includes(part.orientation__orientation_name)
              )
              .flatMap((part) => {
                let addedAttributes = 0;
                return part.attributes.flatMap((attribute) => {
                  const score = instrumentType !== "LOI Self" ? attribute.respondent_score : attribute.self_score;
                  if (addedAttributes < 3 && score !== null) {
                    addedAttributes++;
                    return [score];
                  } else {
                    return [];
                  }
                });
              }),

            borderWidth: 0.1,
            barThickness: 10,

          })),
        };

        const colors = [
          {
            backgroundColor: "rgba(45, 178, 217, 0.4)",
            borderColor: "rgba(45, 178, 217, 0.7)",
          },
          {
            backgroundColor: "rgba(52, 49, 186, 0.4)",
            borderColor: "rgba(52, 49, 186, 0.7)",
          },
          {
            backgroundColor: "rgba(229, 156, 136, 0.4)",
            borderColor: "rgba(229, 156, 136, 0.7)",
          },
        ];

        const hubData = {
          labels: hubUniqueAttNames,
          datasets: response.data.data.map((item, index) => ({
            label: relation.length > 1 ? item.report_type : `${new Date(item.created).toISOString().split("T")[0]}`,
            data: item.report_parts
              .filter((part) =>
                storedOrientation.includes(part.orientation__orientation_name)
              )
              .flatMap((part) => {

                return part.attributes.flatMap((attribute) => {
                  const score = instrumentType !== "LOI Self" ? attribute.respondent_score : attribute.self_score;
                  if (
                    score !== null &&
                    hubAllowedAttributeNames.includes(String(attribute.att_name))
                  ) {
                    return [score];
                  } else {
                    return [];
                  }
                });
              }),

            fill: true,
            backgroundColor: colors[index % colors.length].backgroundColor,
            borderColor: colors[index % colors.length].borderColor,
            borderWidth: 1,
            pointRadius: instrumentType === "LOI Self" ? (isMobile ? 2 : 8) : (isMobile ? 1 : 5),


          })),
        };
        const cotterData = {
          labels: cotterUniqueAttNames,
          datasets: response.data.data.map((item, index) => ({
            label: relation.length > 1 ? item.report_type : `${new Date(item.created).toISOString().split("T")[0]}`,
            data: item.report_parts
              .filter((part) =>
                storedOrientation.includes(part.orientation__orientation_name)
              )
              .flatMap((part) => {
                return part.attributes.flatMap((attribute) => {
                  const score = instrumentType !== "LOI Self" ? attribute.respondent_score : attribute.self_score;
                  if (
                    score !== null &&
                    cotterAllowedAttributeNames.includes(String(attribute.att_name))
                  ) {
                    return [score];
                  } else {
                    return [];
                  }
                });
              }),

            borderWidth: 1,
            barThickness: 20,
          })),
        };


        const radarData = {
          labels: radarAttributeNames,
          datasets: response.data.data.map((item, index) => ({
            label: relation.length > 1 ? item.report_type : `${new Date(item.created).toISOString().split("T")[0]}`,
            data: item.report_parts
              .filter((part) =>
                storedOrientation.includes(part.orientation__orientation_name)
              )
              .flatMap((part) => {
                if (part.attributes && part.attributes.length > 0) {
                  return part.attributes.map(
                    (attribute) => instrumentType !== "LOI Self" ? attribute.respondent_score : attribute.self_score
                  );
                } else {
                  return [];
                }
              }),
            backgroundColor: colors[index % colors.length].backgroundColor,
            borderColor: colors[index % colors.length].borderColor,
            borderWidth: 1,
            barThickness: 20,
            fill: false,
            pointRadius:
              isTablet ? 3 : isMobile ? 2 : 8,

            tension: 0.5

          })),
        };
        setRadarData(radarData);
        const getLifeWheelColors = assignColors(data);
        setLifeWheelBardData(getLifeWheelColors.attributeColors);

        setHubWheelBardData(hubData);
        setCotterWheelBardData(assignColors2(cotterData));


        let result = response.data.data.map((item, index) => {
          const reportParts = item.report_parts.map((part) => {
            return {
              id: part.orientation__id,
              orientation__orientation_name: part.orientation__orientation_name,
              attributes: part.attributes,
            };
          });

          // Get the filterData from localStorage
          const filterData = JSON.parse(localStorage.getItem("filterData"));

          // Check if relation exists and has more than 2 items
          const useRelation = filterData && filterData.formData &&
            filterData.formData.relation &&
            filterData.formData.relation.length > 1;

          return {
            // Use relation if it exists and has more than 2 items, otherwise use the date
            created: useRelation ? filterData.formData.relation[index] :
              (item.created ? `${new Date(item.created).toISOString().split("T")[0]}` : 'date'),
            reportParts: reportParts,
          };
        });

        let filteredResult = result.map((parts) => {
          parts.reportParts = parts.reportParts.filter((part) =>
            storedOrientation.includes(part.orientation__orientation_name)
          );
          return parts;
        });

        setDownloadData(filteredResult);
      })
      .catch((error) => {
        console.error("Error fetching attribute list:", error);
      });
  }, [reload]);
  useEffect(() => {

    const radarScoreData = {
      datasets: responseData.map((item, index) => ({

        id: index + 1,
        name: relation.length > 1 ? item.report_type : `${new Date(item.created).toISOString().split("T")[0]}`,
        attributes: item.report_parts
          .filter((part) =>
            selectedOrientation.includes(part.orientation__orientation_name)
          )
          .flatMap((part) => {
            let mappedAttributes = [];

            if (part.attributes && part.attributes.length > 0) {
              part.attributes.forEach((attribute) => {

                mappedAttributes.push({
                  att_name: attribute.att_name,
                  table_heading: attribute.table_heading,
                  respondent_score: instrumentType !== "LOI Self" ? attribute.respondent_score : attribute.self_score,
                  att_data: attribute.att_data,
                });


              });
            }
            return mappedAttributes;
          }),
      })),
    };
    setRadarScoreData(radarScoreData.datasets);


    const scoreData = {
      datasets: responseData.map((item, index) => ({
        id: index + 1,
        name: relation.length > 1 ? item.report_type : `${new Date(item.created).toISOString().split("T")[0]}`,
        attributes: item.report_parts
          .filter((part) =>
            selectedOrientation.includes(part.orientation__orientation_name)
          )
          .flatMap((part) => {
            let mappedAttributes = [];
            let addedAttributes = 0;
            if (part.attributes && part.attributes.length > 0) {
              part.attributes.forEach((attribute) => {
                if (addedAttributes < 3) {
                  mappedAttributes.push({
                    att_name: attribute.att_name,
                    table_heading: attribute.table_heading,
                    respondent_score: instrumentType !== "LOI Self" ? attribute.respondent_score : attribute.self_score,
                    att_data: attribute.att_data,
                  });
                  addedAttributes++;
                }
              });
            }
            return mappedAttributes;
          }),
      })),
    };
    setScoreData(scoreData.datasets);
    const hubScoreData = {
      datasets: responseData.map((item, index) => ({
        id: index + 1,
        name: relation.length > 1 ? item.report_type : `${new Date(item.created).toISOString().split("T")[0]}`,
        attributes: item.report_parts
          .filter((part) =>
            selectedOrientation.includes(part.orientation__orientation_name)
          )
          .flatMap((part) => {
            let mappedAttributes = [];
            let addedAttributes = 0;
            if (part.attributes && part.attributes.length > 0) {
              part.attributes.forEach((attribute) => {
                if (
                  hubAllowedAttributeNames.includes(String(attribute.att_name))
                ) {
                  mappedAttributes.push({
                    att_name: attribute.att_name,
                    table_heading: attribute.table_heading,
                    respondent_score: instrumentType !== "LOI Self" ? attribute.respondent_score : attribute.self_score,
                    att_data: attribute.att_data,
                  });
                  addedAttributes++;
                }
              });
            }
            return mappedAttributes;
          }),
      })),
    };
    setHubScoreData(hubScoreData.datasets);
    const cotterScoreData = {
      datasets: responseData.map((item, index) => ({
        id: index + 1,
        name: relation.length > 1 ? item.report_type : `${new Date(item.created).toISOString().split("T")[0]}`,
        attributes: item.report_parts
          .filter((part) =>
            selectedOrientation.includes(part.orientation__orientation_name)
          )
          .flatMap((part) => {
            let mappedAttributes = [];
            let addedAttributes = 0;
            if (part.attributes && part.attributes.length > 0) {
              part.attributes.forEach((attribute) => {
                if (
                  cotterAllowedAttributeNames.includes(
                    String(attribute.att_name)
                  )
                ) {
                  mappedAttributes.push({
                    att_name: attribute.att_name,
                    table_heading: attribute.table_heading,
                    respondent_score: instrumentType !== "LOI Self" ? attribute.respondent_score : attribute.self_score,
                    att_data: attribute.att_data,
                  });
                  addedAttributes++;
                }
              });
            }
            return mappedAttributes;
          }),
      })),
    };
    setCotterScoreData(cotterScoreData.datasets);
  }, [selectedOrientation, lifeWheelBardData]);

  function assessmentReportList() {
    let data;
    let endpoint;

    if (instrumentType === "LOI Self") {

      data = {
        assessments: storedIdsArray,
        user: Number(participantId),
      };
      endpoint = "/assessments/report/yoy-self";
    } else {

      data = {
        "user_assessment": storedIdsArray,
        "user": Number(participantId),
        "relation_group_id": relationId,
        "relation_group_name": relation,
        "screen_type": "assessment_summary"
      };
      endpoint = "/assessments/comparison/all/report";
    }

    return axios.post(addAccessTokenToUrl(endpoint), data);
  }

  const labels = [...storedOrientation];


  const indexMap = {};
  lifeWheelOrientationOrder.forEach((element, index) => {
    indexMap[element] = index;
  });


  labels.sort((x, y) => {
    if (indexMap[x] === undefined) {
      return 1;
    } else if (indexMap[y] === undefined) {
      return -1;
    } else {
      return indexMap[x] - indexMap[y];
    }
  });


  const prepareDatesForIds = (data) => {
    const datesForIds = {};
    data.forEach(item => {
      datesForIds[item.id] = new Date(item.created).toISOString().split("T")[0];
    });
    return datesForIds;
  };


  const datesForIds = prepareDatesForIds(responseData);




  return (
    <div>
      {pdfLoading && (
        <Pdfloader loaderText="Downloading your file please wait..." />
      )}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ width: isMobile ? "100%" : "auto" }}>
          <ButtonDropdown


            isOpen={dropdownOpen}
            toggle={toggleInstrumentDropdown}
            style={{
              width: "100%",
              height: "50px",
              background: "white",
            }}
          >
            <DropdownToggle


              onClick={toggleInstrumentDropdown}
              style={{
                width: "100%",
                height: "50px",
                display: "flex",
                justifyContent: "center",
                background: "#ff6600",
                border: "none",
                textAlign: "center",
                alignContent: "center",
                alignItems: "center",
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",

              }}

            >
              <div>
                <img
                  src={DownloadReportSvg}
                  alt="Compare Icon"
                  style={{ marginRight: "10px" }}
                />{" "}
                DOWNLOAD REPORT
              </div>
            </DropdownToggle>
            <DropdownMenu style={{ width: "100%" }}>
              <DropdownItem
                style={{
                  width: "100%",
                  height: "50px",
                  background: "white",
                  display: "flex",
                  alignItems: "center",
                  paddingLeft: "40px",
                }}
                onClick={handleDownloadPdf}
              >
                DOWNLOAD PDF
              </DropdownItem>
              <hr />
              <DropdownItem
                style={{
                  width: "100%",
                  height: "50px",
                  background: "white",
                  display: "flex",
                  alignItems: "center",
                  paddingLeft: "40px",
                }}
                onClick={handleDownloadPpt}
              >
                DOWNLOAD PPT
              </DropdownItem>
            </DropdownMenu>
          </ButtonDropdown>
        </div>
      </div>



      <div
        style={{
          fontSize: isMobile ? "18px" : "24px",
          fontWeight: 600,
          color: "#33383E",
          marginTop: "30px",
        }}
      >
        Life Wheel & Long-Term Development Plan Chart
      </div>
      {/* typeof relation === "array" */}
      <div style={{ marginTop: "50px" }}>
        <BarChart bardData={lifeWheelBardData} isMobile={isMobile} isTablet={isTablet} />
        {Array.isArray(relation) && relation.length > 1 ? (
          relation.map((item, index) => {
            const currentColorSet = lifeWheelOrientationColors.get(index);
            if (!currentColorSet || !Object.keys(currentColorSet).length) {
              return null;
            }
            const currentLegendData = labels.map((label) => ({
              label: label,
              color: currentColorSet[label],
            }));
            return (
              <div key={index} style={{ marginTop: '20px' }}>
                <Legend legendData={currentLegendData} title={item} />
              </div>
            );
          })
        ) : (
          storedIdsArray.map((id, index) => {
            const currentColorSet = lifeWheelOrientationColors.get(index);
            if (!currentColorSet || !Object.keys(currentColorSet).length) {
              return null;
            }
            const currentLegendData = labels.map((label) => ({
              label: label,
              color: currentColorSet[label],
            }));
            const singleDateForId = { [id]: datesForIds[id] };
            return (
              <div key={id} style={{ marginTop: '20px' }}>
                <Legend legendData={currentLegendData} datesForIds={singleDateForId} />
              </div>
            );
          })
        )}





        <hr
          style={{
            height: "2px",
            border: "none",
            borderBottom: "1px dashed #D4DEF0",
            paddingTop: "30px",
          }}
        />
        <ScoreBoard
          barData={scoreData}
          onSelectedOrientationChange={handleSelectedOrientationChange}
        />
      </div>
      <hr
        style={{
          height: "2px",
          border: "none",
          borderBottom: "1px solid #D4DEF0",
          paddingTop: "30px",
        }}
      />
      <div
        style={{
          fontSize: isMobile ? "18px" : "24px",
          fontWeight: 600,
          color: "#33383E",
          marginTop: "30px",
        }}
      >
        Engagement & Quality – Hub of your wheel
      </div>
      <div style={{ marginTop: "50px" }}>
        <RadarChartWheel bardData={hubWheelBardData} isMobile={isMobile} isTablet={isTablet} />
        <hr
          style={{
            height: "2px",
            border: "none",
            borderBottom: "1px dashed #D4DEF0",
            paddingTop: "30px",
          }}
        />
        <ScoreBoard
          barData={hubScoreData}
          onSelectedOrientationChange={handleSelectedOrientationChange}
        />
      </div>
      <hr
        style={{
          height: "2px",
          border: "none",
          borderBottom: "1px solid #D4DEF0",
          paddingTop: "30px",
        }}
      />
      <div
        style={{
          fontSize: isMobile ? "18px" : "24px",
          fontWeight: 600,
          color: "#33383E",
          marginTop: "30px",
        }}
      >
        Structure and Timing – The Cotter Pin of your Wheel
      </div>
      <div style={{ marginTop: "50px" }}>
        <BarChart bardData={cotterWheelBardData} isMobile={isMobile} isTablet={isTablet} />

        {storedIdsArray.map((id, index) => {

          const currentColorSet = uniqueHUbCotter.get(index);

          if (!currentColorSet || !currentColorSet.size) {
            return null;
          }

          const currentLegendData = labels.map((label, labelIndex) => ({
            label: label,
            color: Array.from(currentColorSet)[labelIndex],
          }));


          const singleDateForId = { [id]: datesForIds[id] };

          return (
            <div key={id} style={{ marginTop: '20px' }}>
              <Legend legendData={currentLegendData} datesForIds={singleDateForId} />
            </div>
          );
        })}

        <hr
          style={{
            height: "2px",
            border: "none",
            borderBottom: "1px dashed #D4DEF0",
            paddingTop: "30px",
          }}
        />
        <ScoreBoard
          barData={cotterScoreData}
          onSelectedOrientationChange={handleSelectedOrientationChange}
        />
      </div>

      <hr
        style={{
          height: "2px",
          border: "none",
          borderBottom: "1px solid #D4DEF0",
          paddingTop: "30px",
        }}
      />


      <div
        style={{
          fontSize: isMobile ? "18px" : "24px",
          fontWeight: 600,
          color: "#33383E",
          marginTop: "30px",
        }}
      >
        Overall Report
      </div>
      <div style={{ alignItems: "center", alignContent: "center" }}>
        <div style={{ marginTop: isMobile ? "10px" : '50px' }}>

          <LineChart bardData={radarData} isMobile={isMobile} isTablet={isTablet} />

        </div>
        <hr
          style={{
            height: "2px",
            border: "none",
            borderBottom: "1px dashed #D4DEF0",
          }}
        />
        <ScoreBoard
          barData={radarScoreData}
          onSelectedOrientationChange={handleSelectedOrientationChange}
        />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/new/Components/Reports/Assessment-Reports/Report-charts/index.jsx